
export const COUNTRY_CODE_TO_CURRENCY = {
  GB: 'GBP',
  FK: 'GBP',
  GI: 'GBP',
  IO: 'GBP',
  GG: 'GBP',
  IM: 'GBP',
  JE: 'GBP',
  SH: 'GBP',
  GS: 'GBP',
  AT: 'EUR',
  BE: 'EUR',
  HR: 'EUR',
  CY: 'EUR',
  EE: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  GR: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LV: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  MT: 'EUR',
  NL: 'EUR',
  PT: 'EUR',
  SK: 'EUR',
  SI: 'EUR',
  ES: 'EUR',
  AD: 'EUR',
  XK: 'EUR',
  MC: 'EUR',
  ME: 'EUR',
  SM: 'EUR',
  VA: 'EUR',
  BG: 'EUR',
  CZ: 'EUR',
  HU: 'EUR',
  PL: 'EUR',
  RO: 'EUR',
  SE: 'EUR',
  DK: 'EUR',
  NO: 'EUR',
  IS: 'EUR',
  LI: 'EUR',
  MD: 'EUR',
  CU: 'EUR',
  KP: 'EUR',
  SY: 'EUR',
  IR: 'EUR',
  VE: 'EUR',
  UA: 'UAH'
}
